// Component
export default () => {
    const copyBtn = document.querySelectorAll('[data-brand-copy="btn"]')

    // If there's no signature copy buttons, return
    if (!copyBtn)
        return

    const watch = (el) => {
        const card = el.closest('[data-brand-copy="card"]')

        if (!card)
            return

        el.addEventListener('click', () => copy(card))
    }

    const copy = (card) => {
        const markup = card.querySelector('[data-brand-copy="image"] figure')
            || card.querySelector('[data-brand-copy="markup"]')

        if (!markup)
            return

        if (typeof ClipboardItem === 'undefined') {
            console.error('[Brand Asset Copy]\n'
                + 'This feature is not available in the browser you are using.\n'
                + 'Please select the text and copy to your email.')
            return
        }

        const type = 'text/html'
        const blob = new Blob([markup.innerHTML], { type }) // eslint-disable-line no-undef
        const data = [new ClipboardItem({ [type]: blob })] // eslint-disable-line no-undef

        const error = () => {
            console.error('[Brand Asset Copy] There was an error, try again.')
        }

        const success = () => {
            const css = 'brand-card-copied'
            card.classList.add(css)

            setTimeout(() => {
                card.classList.remove(css)
            }, 2000)
        }

        navigator.clipboard
            .write(data)
            .then(success, error)
    }

    copyBtn.forEach(btn => watch(btn))
}
